import { attributes, define } from "@type-r/models";
import { Loading } from "lqx-react";
import * as React from "react";
import { useIO, useLinked } from "@type-r/react";
import { globalStore } from "api";
import { PendingActionsInvoices, TimeRangeTypes } from "../../api";
import { LandingItems } from "../../common/landing-items";

const TIME_RANGE_DEFAULT = TimeRangeTypes.slice(1)[0].val;

@define
export class ReviewApprovedInvoicesState extends attributes({
    invoices: [PendingActionsInvoices],
    isReady:Boolean
}) {
    async fetch(options?) {
        const approvedInvoices = await PendingActionsInvoices.fetchApprovedInvoices(options ? options.$timeRange.value : TIME_RANGE_DEFAULT);
        
        this.invoices.set(approvedInvoices);

        this.invoices.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        return this;
    }

    getCount(){
        return this.invoices.reduce((sum: number, curr) => sum + (curr ? curr.count : 0), 0);
    }
}

export const ApprovedInvoices = ({ state }: { state: ReviewApprovedInvoicesState }) => {

    const $timeRange = useLinked(TIME_RANGE_DEFAULT);
    state.isReady = useIO(async () => {
        await state.fetch({ $timeRange });
    }, [$timeRange.value]);

    return (
        state.isReady ?
            <LandingItems
                title={`Review items (${state.getCount()})`}
                items={state.invoices}
                linkUrl='/invoices/statement'
                type='approved-invoices'
                $timeRange={$timeRange}
            />
            :
            <Loading />
    );
}